// extracted by mini-css-extract-plugin
export default {"root":"HeaderSearch_root__PuH5b","input":"HeaderSearch_input__ZwKXw","button":"HeaderSearch_button__M3vd6"};